import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Switch, Text } from '@mantine/core';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
export default function EntityConfigSettings({
  campaignId = null,
  effortId = null,
  onUpdate,
  useKeywords = false,
  useCheckins = false,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    use_keywords: true,
    use_checkins: true,
  });

  useEffect(() => {
    setFormValues({
      ...formValues,
      use_keywords: useKeywords,
      use_checkins: useCheckins,
    });
  }, []);

  function onSubmit() {
    setLoading(true);

    const req = {
      ...formValues,
    };

    if (effortId) req.campaign_effort_id = effortId;
    if (campaignId) req.campaign_id = campaignId;

    axios
      .post(`/update-settings/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t('common:saved') + '!');
        onUpdate();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <div>
      <Text fw={600} mb="xs">
        {t('common:setup')}
      </Text>
      <Switch
        label={t('mixer:entity_config_settings:allow_keyword_entry')}
        size="sm"
        mb="md"
        onChange={(e) =>
          setFormValues({
            ...formValues,
            use_keywords: !formValues.use_keywords,
          })
        }
        checked={formValues.use_keywords === true}
      />
      <Switch
        label={t('mixer:entity_config_settings:allow_check_in_entry')}
        size="sm"
        mt="md"
        onChange={(e) =>
          setFormValues({
            ...formValues,
            use_checkins: !formValues.use_checkins,
          })
        }
        checked={formValues.use_checkins === true}
      />
      <Button loading={loading} mt="lg" size="sm" onClick={onSubmit}>
        {t('common:save')}
      </Button>
    </div>
  );
}
